import { getModuleState as getEventInfoModuleState } from "../../selectors";
import { ICropGrowthStage } from "./models";
import { ISampleTissueState } from "./reducer";

export const SAMPLE_TISSUE_STATE_KEY = "SAMPLE_TISSUE_STATE";

export const getModuleState = (state: unknown): ISampleTissueState =>
    getEventInfoModuleState(state)[SAMPLE_TISSUE_STATE_KEY];

export const getCropGrowthStageList = (state: unknown): ICropGrowthStage[] =>
    getEventInfoModuleState(state)[SAMPLE_TISSUE_STATE_KEY].cropGrowthStageList;

export const getCropGrowthStageGuid = (state: unknown): string | null =>
    getEventInfoModuleState(state)[SAMPLE_TISSUE_STATE_KEY].cropGrowthStageGuid;

export const getPlantPartGuid = (state: unknown): string | null =>
    getEventInfoModuleState(state)[SAMPLE_TISSUE_STATE_KEY].plantPartGuid;
